export default __webpack_public_path__ + "static/media/reviews@2x.333a3a81.png";